<template lang="pug">
#appCheckout(class="flex container mt-8 pb-8 flex-wrap lg1024:p-0 lg1024:pb-8 p-4", :class="{'min-h-by-content': afterSummaryPage}")
  template(v-if="afterSummaryPage")
    router-view
  template(v-else)
    div(class="lg1024:flex-1 lg1024:min-w-0 lg1024:pa-0 lg1024:pr-8 xl1280:pr-14 pa-2 w-full pb-10 lg1024:pb-0")
      h2(class="lg1024:text-4xl text-2xl font-bold") {{ $t('checkout_title') }}
      div(class="flex")
        div(class="afterTitle mb-8", :class="{ active: countryPopup }")
          span(class="text-lighter") {{ $t('receiver_country') }}:&nbsp;
          span(class="font-medium") {{ country.name }}
          span(class="quest-icon")
            svg(@click="countryPopup = !countryPopup", width="20", height="20", viewBox="0 0 20 20", fill="none", xmlns="http://www.w3.org/2000/svg")
              path(fill-rule="evenodd", clip-rule="evenodd", d="M10 2C5.58172 2 2 5.58172 2 10C2 14.4183 5.58172 18 10 18C14.4183 18 18 14.4183 18 10C18 5.58172 14.4183 2 10 2ZM0 10C0 4.47715 4.47715 0 10 0C15.5228 0 20 4.47715 20 10C20 15.5228 15.5228 20 10 20C4.47715 20 0 15.5228 0 10Z", fill="#666F76")
              path(d="M9.63636 13.4545C9.53247 13.4545 9.44589 13.4199 9.37662 13.3506C9.30736 13.2814 9.27273 13.1948 9.27273 13.0909V12.3983C9.29582 11.7864 9.45166 11.2612 9.74026 10.8225C10.0289 10.3838 10.4502 9.88167 11.0043 9.31602C11.4545 8.85426 11.7835 8.4733 11.9913 8.17316C12.1991 7.87302 12.303 7.54401 12.303 7.18615C12.303 6.65512 12.0779 6.23377 11.6277 5.92208C11.189 5.61039 10.6753 5.45455 10.0866 5.45455C8.71284 5.45455 7.90476 6.14719 7.66234 7.53247C7.60462 7.78644 7.45455 7.91342 7.21212 7.91342H6.38095C6.26551 7.91342 6.17316 7.87879 6.1039 7.80952C6.03463 7.74026 6 7.64791 6 7.53247C6.02309 6.89755 6.20202 6.31457 6.5368 5.78355C6.88312 5.24098 7.36797 4.80808 7.99134 4.48485C8.61472 4.16162 9.33045 4 10.1385 4C10.9928 4 11.7085 4.15007 12.2857 4.45022C12.8745 4.73882 13.3074 5.11977 13.5844 5.59307C13.8615 6.05483 14 6.55123 14 7.08225C14 7.671 13.8672 8.17893 13.6017 8.60606C13.3362 9.03319 12.938 9.52958 12.4069 10.0952C11.9683 10.557 11.6392 10.9495 11.4199 11.2727C11.2006 11.5844 11.0736 11.9365 11.039 12.329C11.0159 12.6522 11.0043 12.8947 11.0043 13.0563C10.9466 13.3218 10.8023 13.4545 10.5714 13.4545H9.63636ZM9.49784 16.2944C9.3824 16.2944 9.28427 16.2597 9.20346 16.1905C9.1342 16.1097 9.09957 16.0115 9.09957 15.8961V14.8398C9.09957 14.7244 9.1342 14.632 9.20346 14.5628C9.28427 14.482 9.3824 14.4416 9.49784 14.4416H10.6234C10.7388 14.4416 10.8369 14.482 10.9177 14.5628C10.9986 14.632 11.039 14.7244 11.039 14.8398V15.8961C11.039 16.0115 10.9986 16.1097 10.9177 16.1905C10.8369 16.2597 10.7388 16.2944 10.6234 16.2944H9.49784Z", fill="#666F76")
          div(class="popup")
            div(class="bubble rounded-lg lg1024:p-6 p-3")
              div(class="text text-white mb-4 text-sm") {{ $t('change_country') }}
              .popup-footer(class="flex justify-end md768:justify-start flex-wrap lg1024:flex-nowrap gap-3")
                a(href="/basket/", class="btn btn-densed whitespace-no-wrap font-medium bg-white flex items-center p-3 lg1024:px-6 rounded text-sm") {{ $t('back_to_cart_button') }}
                div(class="btn btn-densed cursor-pointer whitespace-no-wrap font-medium bg-transparent border-white border-2 text-white flex items-center text-sm p-3 lg1024:px-6 lg1024:mr-6 rounded", @click="countryPopup = false") {{ $t('close') }}
      div(v-if="errors.length")
        div(v-for="(error, index) in errors", :key="index") {{ error }}
      CheckoutUnAuth(ref="checkoutUnAuth")

    div(class="w-[calc(100%+2rem)] lg1024:w-[392px] lg1024:flex-none order-first lg1024:order-none -mx-4 -mt-12 mb-6 lg1024:m-0")
      Basket(@updated="updated")
  component(v-if="devWarsComponent", :is="devWarsComponent")

</template>

<script>
import CheckoutUnAuth from '@/views/CheckoutUnAuth.vue'
import Basket from '@/components/Basket.vue'
import { mapState } from 'vuex'
import { defineAsyncComponent } from 'vue'
import { isClickOnElement, useFormatMoney } from '@/utils/helpers'

// DevWars — см. .agents/skills/devwars/SKILL.md
const DevWarsPanelAsync = import.meta.env.DEV
  ? defineAsyncComponent(() => import('@/components/dev/DevWarsPanel.vue'))
  : null

export default {
  components: {
    Basket,
    CheckoutUnAuth,
  },
  data() {
    return {
      errors: [],
      orderType: undefined,
      interval: false,
      countryPopup: false,
      devWarsComponent: DevWarsPanelAsync,
    }
  },
  methods: {
    updated() {
      if (this.$refs.checkoutUnAuth) this.$refs.checkoutUnAuth.updateBasket()
    },
  },
  computed: {
    ...mapState(['country', 'currency']),
    afterSummaryPage() {
      return this.$route.name === 'AfterSummary'
    },
  },
  provide() {
    return {
      formatMoney: (value) =>
        useFormatMoney(this.country.code, this.currency, value),
      isClickOnElement,
    }
  },
  async mounted() {
    if (document.querySelector('.vpn_message__container') !== null) {
      document.querySelector('#appCheckout').style.marginTop = '24px'
    } else {
      document.querySelector('#appCheckout').style.marginTop = '0px'
    }
    this.interval = setInterval(() => {
      if (
        this.$el.querySelector('input.pac-target-input') &&
        this.$el
          .querySelector('input.pac-target-input')
          .getAttribute('autocomplete') !== 'disabled'
      )
        this.$el
          .querySelector('input.pac-target-input')
          .setAttribute('autocomplete', 'disabled')
    }, 1000)

    // ловим ошибку из main.js
    if (this.$initError) {
      this.errors.push(this.$initError.message)
    }

    // DRepeatY
    this.orderType = this.$store.getters.getOrderType // зачем везде эти клоны? это основная причина всех проблем
  },
}
</script>

<style lang="scss">
@use '@/assets/css/base.scss' as *;
@import './assets/css/tailwind.css';
#appCheckout {
  font-family: Rubik, Arial, sans-serif;
  color: #333f48;
  line-height: 1.5;
  &.min-h-by-content {
    min-height: max-content;
    margin-bottom: 48px;
  }

  & input[type='text'],
  & input[type='email'],
  & input[type='phone'],
  & input[type='search'],
  & input[type='number'],
  & .pac-target-input,
  & .phoneSelect,
  & textarea,
  & select,
  .phoneSelect input,
  .profiles,
  .old-profiles-block {
    border-radius: 6px;

    @media (max-width: 480px) {
      border-radius: 8px !important;
    }
  }

  .types {
    .type {
      border-radius: 8px;
    }
  }
}
#appCheckout h2 {
  line-height: 1.5;
}

#appCheckout input[type='text']:focus,
#appCheckout input[type='email']:focus,
#appCheckout input[type='phone']:focus,
#appCheckout input[type='number']:focus,
#appCheckout .has-error:focus,
#appCheckout .has-error.focused {
  border: 2px solid #858c91;
  outline: none;

  @media (max-width: 480px) {
    border: 1px solid #858c91;
  }
}

#appCheckout .has-error {
  border: 2px solid #ff585d;

  @media (max-width: 480px) {
    border: 1px solid #ff585d;
  }
}

.btn-densed {
  height: 32px !important;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}

.checkout-button {
  background: #fa5f55;
  border-radius: 10px;
  color: #fff;
  font-weight: 500;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 48px;
  padding-left: 1rem;
  padding-right: 1rem;
  cursor: pointer;
}

.rounded-none {
  border-radius: 0px !important;
}

.checkout-button.checkout-button-white {
  background: #fff;
  border: 1px solid #f8f9f9;
  box-shadow: 0px 2px 8px rgba(0, 16, 48, 0.08);
  color: #333f48;
}

.checkout-button.checkout-button-second {
  background: #fff;
  border: 1px solid rgba(51, 63, 72, 0.75);
  color: rgba(51, 63, 72, 0.75);
}

.checkout-button.checkout-button-base {
  font-weight: 400;
  background: #f36355;
  color: #ffffffd6;
}

.checkout-button.checkout-button-third {
  font-weight: 400;
  background: #fdc9c240;
  color: #d6483d;
}
.checkout-button.checkout-button-ghost {
  background: none;
  border: none;
  color: rgba(51, 63, 72, 0.75);
  box-shadow: none;
}

.checkout-button.checkout-button-disabled,
.checkout-button.disabled {
  background: #f8f9f9;
  border: 1px solid #dcdcdc;
  color: #dcdcdc;
}

.afterTitle {
  position: relative;
}

.afterTitle .popup {
  position: absolute;
  left: calc(100% + 20px);
  top: -11px;
  z-index: 2;
  transition: opacity 600ms ease;
  opacity: 0;
  pointer-events: none;
}

.afterTitle.active .popup {
  opacity: 1;
  pointer-events: initial;
  max-width: 450px;
}

.afterTitle .popup .bubble {
  background: #333f48;
}

.afterTitle .popup .bubble::before {
  background: #333f48;
  content: '';
  display: block;
  width: 15px;
  height: 15px;
  position: absolute;
  transform: rotate(45deg) translateX(-50%);
  left: 0;
  top: 20px;
}

.quest-icon {
  display: inline-block;
  width: 18px;
  height: 18px;
  position: relative;
  margin-left: 11px;
  top: 3px;
}

.quest-icon svg {
  width: 18px;
  height: 18px;
  cursor: pointer;
}

.slide-fade-enter-active {
  transition: all 0.3s ease;
}
.slide-fade-leave-active {
  transition: all 0.3s;
}
.slide-fade-enter, .slide-fade-leave-to
  /* .slide-fade-leave-active below version 2.1.8 */ {
  transform: translateX(10px);
  opacity: 0;
}
.skeleton-container {
  border-width: 2px;
  border-color: rgb(238, 238, 238) !important;
}

.delivery-type__item:hover {
  cursor: pointer;
}
.active-delivery-type-item {
  background-color: #ff585d08 !important;
  border: 2px solid #d6483d !important;
}
.checkout-checkbox {
  -webkit-appearance: none;
  width: 24px;
  height: 24px;
  border: 2px solid #d1d8dd;
  outline: none;
  position: relative;
  border-radius: 6px;
}

.checkout-checkbox:hover {
  border: 2px solid red;
}

.checkout-checkbox:checked {
  background-image: url('./assets/img/checkbox.png');
  background-position: center;
  border: 1px solid transparent;
  background-size: cover;
}

.checkout-checkbox__label {
  position: relative;
  top: -2px;
}

.grayHolder {
  background: #f8f9f9;
  border: 1px solid #f2f2f2;
  border-radius: 4px;
}

.purpleHolder {
  background: #f7f8ff;
  border: 1px solid #d0d3ff;
  border-radius: 4px;
}

.redHolder {
  background: #ff585d08;
  border: 1px solid #ff585d;
  border-radius: 4px;
  color: #ff585d;
}
.yellowHolder {
  background: #fffcf5;
  border: 1px solid #feecb9;
  border-radius: 4px;
  color: #eda12f;
}

span.required {
  color: #a72a00;
}

span.required::after {
  content: ' ';
}
.input-wrap {
  padding: 9px 12px;
  height: 44px;
  border-radius: 6px;
  border: 2px solid #d1d8dd;
  background: white;
  outline: none;
  transition: 0.3s;

  @media (max-width: 480px) {
    border: 1px solid #d1d8dd;
    border-radius: 8px;
  }

  &:focus {
    border: 2px solid #8e9aa4;
    outline: none;

    @media (max-width: 480px) {
      border: 1px solid #858c91;
    }
  }

  &:hover {
    background: #f3f8fc;
  }

  &:disabled {
    border: 2px solid #acb9c3 !important;
    opacity: 0.5;
    background: rgba(59, 109, 149, 0.08);

    @media (max-width: 480px) {
      border: 1px solid #acb9c3;
    }
  }
}
label:hover ~ .input-wrap {
  background: white;
}

label:hover ~ .input-wrap:disabled {
  background: rgba(59, 109, 149, 0.08);
}
@media (max-width: 1023px) {
  .text-xl,
  .text-2xl,
  .text-3xl {
    max-width: calc(90vw - 2rem);
  }

  .afterTitle .popup {
    top: 40px;
    left: 0;
  }
  .afterTitle.innerTitle .popup {
    left: -1rem;
  }

  .afterTitle .popup .bubble {
    width: calc(100vw - 2rem);
    max-width: 450px;
  }

  .afterTitle .popup .bubble::before {
    left: 50%;
    top: -2px;
  }
}

html.direction--rtl {
  // direction: rtl;

  @mixin rtl-margin-side($rtl-value) {
    margin-left: 0;
    margin-right: $rtl-value;
  }

  .gapMarR-s {
    margin-right: 0;
    margin-left: 8px;
  }

  .afterTitle {
    .quest-icon {
      @include rtl-margin-side(11px);
    }

    .popup {
      left: unset;
      right: 0;

      .bubble::before {
        left: calc(50% - 4px);
      }

      .popup-footer {
        justify-content: unset;
      }
    }

    &.innerTitle {
      align-items: center;
      h3 {
        @include rtl-margin-side(0.5rem);
      }
      .popup {
        left: unset;
        right: 0;
        top: 40px;
        .bubble::before {
          left: calc(50% + 56px);
        }
      }
    }
  }

  .payment-info {
    flex-direction: row-reverse;
    justify-content: flex-end;
    .content {
      width: unset;
    }
  }
  .profile-info,
  .address-info,
  .delivery-info {
    margin-right: unset;
    span {
      @include rtl-margin-side(1rem);
    }
  }

  .locations-info {
    column-gap: 1rem;
  }

  .profile-info {
    span {
      direction: ltr;
      text-align: right;
    }
  }

  .walletInput {
    margin-right: 0;
  }
  .walletButton {
    margin-right: 0.5rem;
  }

  .checkbox-labeled,
  .radio-labeled {
    width: 100%;
    align-items: flex-start;
    margin-right: 0;
    input.checkout-checkbox {
      margin-right: 0;
    }
    label {
      width: unset;
      @include rtl-margin-side(0.5rem);
    }
    &.use-wallet {
      justify-content: flex-start;
    }
  }

  #position-input__main-form::-webkit-search-cancel-button {
    position: relative;
    transform: translateX(2rem);
  }
  .search-icon {
    right: unset;
    padding-right: unset;
    left: 0;
    padding-left: 1rem;
  }
  .pickpoint-row {
    .pickpoint-row--footer {
      .button-wrapper {
        a {
          @include rtl-margin-side(auto);
        }
      }
    }
  }

  #AdditionalInfoBlockVue {
    .checkbox-labeled {
      input.checkout-checkbox {
        margin-top: 2px;
        min-width: 16px;
      }
    }
  }

  .modal-window {
    h3 {
      margin-right: 0;
      margin-left: auto;
    }
    .checkout-button-second {
      @media (min-width: 640px) {
        @include rtl-margin-side(1rem);
      }
    }
  }
  #pickpoint-phone {
    direction: ltr;
    text-align: right;
  }
  #pickpointList {
    .filter {
      justify-content: space-between;
    }
    div.checkout-button {
      @include rtl-margin-side(1rem);
    }
  }

  .address-controls {
    flex-direction: row-reverse;
    .close-modal {
      flex-direction: row-reverse;
    }
  }

  .basket {
    .order-bonus {
      direction: ltr;
    }
  }

  .address-controls {
    flex-direction: row;
    .close-modal {
      flex-direction: row;
      img {
        transform: rotate(180deg);
      }
      .font-medium {
        @include rtl-margin-side(1rem);
      }
    }
  }
  @media (min-width: 768px) {
    #AdditionalInfoBlockVue {
      .checkbox-labeled {
        input.checkout-checkbox {
          margin-top: 6px;
        }
      }
    }
  }

  @media (min-width: 1024px) {
    .afterTitle {
      .popup {
        right: calc(100% + 20px);
        .bubble::before {
          transform: rotate(135deg) translateX(-50%);
          left: unset;
          right: -2px;
        }
      }

      &.innerTitle {
        .popup {
          top: -4px;
          right: 216px;
        }
      }
    }
    #DeliveryTypes {
      .pickpoint-buttons {
        @include rtl-margin-side(1rem);
      }
    }
    .list-checkbox {
      flex-wrap: nowrap;
      .checkbox-labeled {
        width: unset;
        margin-left: 1rem;
      }
    }
    .fioBlock {
      .name-inputs {
        column-gap: 1rem;
        .name-input {
          min-width: 1px;
          padding-right: 0;
        }
      }
    }
  }
}

.notification_count {
  display: flex !important;
  align-items: center !important;
  top: -5px !important;
  padding-top: 1px !important;
}
.city-button-loader {
  visibility: hidden !important;
}
</style>
